import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Register the service worker for PWA + push notifications
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .catch((err) => console.warn("SW registration failed:", err));
  });

  // Listen for the SW's "SW_UPDATED" broadcast (fired when a new SW activates
  // and claims this client) — force a reload so the just-deployed HTML/JS is
  // picked up immediately. Prevents the "blank white screen after redeploy"
  // that used to require deleting + reinstalling the PWA.
  navigator.serviceWorker.addEventListener("message", (event) => {
    if (event.data && event.data.type === "SW_UPDATED") {
      // Prevent an infinite reload loop with a sessionStorage marker.
      if (!sessionStorage.getItem("sw_reloaded_once")) {
        sessionStorage.setItem("sw_reloaded_once", "1");
        window.location.reload();
      }
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
